<div
	[className]="['gen-table-wrapper', tableName] | clsArr"
	[class.without-labels]="!isButtonsWithLabels"
>
	@if (!addOnlyVis) {
		<div class="gen-tbl-header-top">
			<h4 class="gen-title flex-grow-0">
				<span class="gen-title-title">{{ langProps.allName | langVal }}</span>
				@if (tableName === "expenses") {
					<app-gen-upload-prediction-btn isV2 />
				}
			</h4>
			<div class="mis-auto d-flex gap-1">
				<div class="gen-submenu">
					@if (hasFieldHiding) {
						<div
							style="display: inline-block"
							(click)="$event.stopImmediatePropagation()"
						>
							<app-icon
								icon="filter"
								class="gen-filter"
								pointer
								(click)="isFieldHidingFloatOpen = !isFieldHidingFloatOpen"
							/>
							@if (isFieldHidingFloatOpen) {
								<div class="gen-filter vis-flip-div">
									@for (fieldObj of collectionFields; track fieldObj) {
										@if (fieldObj.isHideable) {
											<div class="d-flex gap-2">
												<input
													type="checkbox"
													[checked]="!fieldObj.curHidden"
													(change)="fieldObj.curHidden = !$event.target.checked"
												/>
												{{ fieldObj.langName | langVal }}
											</div>
										}
									}
								</div>
							}
						</div>
					}
					@for (btn of headerModalOpenBtns; track btn) {
						@if (!btn?.visibleCheckedOnly) {
							<app-gen-table-header-btn
								[btn]="btn"
								[checkedRows]="checkedRows()"
							/>
						}
					}
					@if (!hideExport) {
						<button
							class="btn btn-icon"
							titleLang="export"
							(click)="exportRows()"
							icon="export"
						></button>
					}
					@if (
						apiCallPerms.saveNewRow &&
						!isEditDisabled &&
						!avoidNewRow &&
						(addRowIsByPlus || !isNewOpen)
					) {
						<button
							class="btn btn-icon"
							titleLang="add"
							(click)="prepNewRow()"
							icon="plus"
						></button>
					}
				</div>
				<div class="gen-search-container">
					<!-- <div class="filter-row"> -->
					@if (tableName == "expenses") {
						<app-gen-button-group
							optionsListName="base_periods_no_range"
							title_ph_lang="period"
							[actualObj]="this"
							fieldName="period"
							(changeEvent)="search()"
						/>
					}
					@if (filterFields.length) {
						@for (filterObj of filterFields; track filterObj) {
							<div>
								<app-gen-button-group
									[actualObj]="currentFilterValues"
									[fieldName]="filterObj.fieldName"
									[options]="filterObj.opts"
									optionFieldId="value"
									(changeEvent)="runFilters()"
								/>
							</div>
						}
						@if (filterFields.length > 1) {
							<div>
								<div class="button-group">
									<button
										class="btn btn-default"
										(click)="resetFilters(true)"
										titleLang="reset_filters"
									>
										{{ "reset_filters" | langVal }}
									</button>
								</div>
							</div>
						}
					}
					<span class="num-badge">{{ objectCollectionShown.length }}</span>
					@if (searchableFields.length) {
						<div
							class="gen-tbl-search actual-search"
							[spinner]="isSearching"
						>
							<app-gen-input
								[actualObj]="this"
								fieldName="currentSearch"
								(keyupEvent)="search()"
								title_ph_lang="search"
								[addonObject]="{ after: { icon: 'search' } }"
								tabindex="-1"
							/>
							@if (currentSearch?.length) {
								<app-icon
									icon="close"
									pointer
									class="clear-search"
									(click)="clearSearch()"
								/>
							}
						</div>
					}

					@if (hasAssocFilter) {
						<div class="gen-tbl-search">
							<app-autocomplete-with-tags
								(chosenEvent)="changeToFilterAssocUsers($event)"
								title_ph_lang="assoc"
								[fuzzySearchableClasses]="['sub_users']"
							/>
						</div>
					}
					@if (hasTagsFilter) {
						<div class="gen-tbl-search">
							<app-autocomplete-with-tags
								(chosenEvent)="changeToFilterTags($event)"
								title_ph_lang="tags"
							/>
						</div>
					}

					@if (tableName == "inquirers" && inquiry_statuses_names.length) {
						<div class="gen-tbl-search">
							<app-gen-select
								[actualObj]="this"
								fieldName="inquiry_status_id"
								title_ph_lang="patienttype"
								(changeEvent)="changeToFilterInquiryStatus()"
								[options]="inquiry_statuses_names"
							/>
						</div>
					}
					@if (tableName | inArray: ["patients", "inquirers"]) {
						<div class="colstat-extra-small">
							<app-gen-input
								[actualObj]="this"
								fieldName="ageSearch"
								title_ph_lang="age"
								(keyupEvent)="search()"
							/>
						</div>
					}
				</div>
			</div>
		</div>

		<ng-content select="[slot=upper-row]"></ng-content>
		<div class="sorter">
			@if (hasCheckItems) {
				<div
					titleLang="check_items"
					class="action-fields card-check-head"
				>
					<app-check
						(onClick)="
							chooseAllChecked = !chooseAllChecked; chooseAll(chooseAllChecked)
						"
						[isCheck]="chooseAllChecked"
					/>
				</div>
			}
			@if (expanded) {
				<div
					titleLang="check_items"
					class="action-fields card-check-head"
				>
					<button
						(click)="expandAll()"
						class="btn btn-icon"
						titleLang="expand"
						[icon]="isAllExpanded ? 'narrow' : 'expand'"
					></button>
				</div>
			}
			@for (fieldObj of upperCollectionFields; track fieldObj.fieldName) {
				@if (fieldObj.type === "string") {
					<div></div>
				} @else {
					@if (
						!fieldObj.curHidden &&
						fieldObj.isSortable &&
						fieldObj.type !== "hidden" &&
						((eventsService.isMobile && !fieldObj?.hideOnMobile) ||
							(!eventsService.isMobile && !fieldObj?.hideOnNonMobile))
					) {
						<div
							(click)="sort(fieldObj.fieldName)"
							sorter
							[fieldName]="fieldObj.fieldName"
							[displayName]="fieldObj.langName | langVal"
							[sortIsAsc]="sortIsAsc"
							[sortField]="sortField"
							[isSortable]="fieldObj.isSortable"
							[className]="
								[
									'btn btn_default',
									$safeNavigationMigration(fieldObj?.attrs?.cls),
								] | clsArr
							"
						></div>
					}
				}
			}
		</div>
	}

	<!-- end of mobile -->
	<!-- wrapper -->

	<ng-content></ng-content>

	@if (hasCheckedItems) {
		<div
			class="sending-multi"
			[spinner]="isSendingMulti"
		>
			<div>
				<!-- necessary div -->
				@for (btn of headerModalOpenBtns; track btn) {
					@if (btn?.visibleCheckedOnly) {
						<app-gen-table-header-btn-checked
							[btn]="btn"
							[filterField]="filterField"
							[filterFieldValue]="filterFieldValue"
							[checkedRows]="checkedRows()"
							(onIsSendingChange)="isSendingMulti = $event"
						/>
					}
				}
			</div>
		</div>
	}

	@if (!addOnlyVis) {
		<div class="cards-list">
			@if (
				apiCallPerms.saveNewRow && isNewOpen && !isEditDisabled && !avoidNewRow
			) {
				<div class="card-container new-row">
					<div class="card-wrapper">
						<!-- @if (expanded) {
							<div class="action-fields"></div>
						}

						@if (expanded) {
							<div></div>
						}
						@if (hasCheckItems) {
							<div></div>
						} -->
						<div class="card-details">
							@for (
								fieldObj of upperCollectionFields;
								track fieldObj.fieldName
							) {
								@if (
									!genTableService.actionsBottom.includes(fieldObj.type) &&
									!fieldObj.curHidden &&
									fieldObj.type !== "hidden" &&
									((eventsService.isMobile && !fieldObj?.hideOnMobile) ||
										(!eventsService.isMobile && !fieldObj?.hideOnNonMobile))
								) {
									<div
										[style]="{
											width: fieldObj?.attrs?.width || 'auto',
											minWidth: fieldObj?.attrs?.minWidth || 'inherit',
										}"
										[className]="
											[
												$safeNavigationMigration(fieldObj?.attrs?.cls),
												$safeNavigationMigration(
													fieldObj?.attrs?.clsFn?.(newRow)
												),
											] | clsArr
										"
									>
										@if (fieldObj?.attrs?.showLabel) {
											<label>{{ fieldObj.langName | langVal }}</label>
										}
										@if (!fieldObj.attrs?.nonVisNewRow) {
											<ng-container
												*ngTemplateOutlet="
													rowFields;
													context: {
														curRow: newRow,
														fieldObj: fieldObj,
														isNewRow: true,
													}
												"
											/>
										}
									</div>
								}
							}
						</div>
					</div>
					<!-- <div>
						@if (!expanded) {
							<div class="add-btn flex-v-center">
								<button
									class="btn btn-icon"
									(click)="isNewOpen = false"
									icon="cancel"
								></button>
								<app-btn-ext
									#addRowBtn
									text="add"
									[disabled]="!isFormSubmittable"
									[tabindex]="tabindexDomain + 49"
									(clickEv)="addNewRow()"
									[isSpin]="isSaving"
								/>
							</div>
						}
					</div> -->
					@if (expanded) {
						<div class="expanded">
							@for (
								fieldObj of lowerCollectionFields;
								track fieldObj.fieldName
							) {
								@if (
									!fieldObj.attrs?.nonVisNewRow &&
									!fieldObj.curHidden &&
									fieldObj.type !== "hidden" &&
									((eventsService.isMobile && !fieldObj?.hideOnMobile) ||
										(!eventsService.isMobile && !fieldObj?.hideOnNonMobile))
								) {
									<div
										[style]="{
											width: fieldObj?.attrs?.width || 'auto',
											minWidth: fieldObj?.attrs?.minWidth || 'inherit',
										}"
										[className]="
											[
												$safeNavigationMigration(fieldObj?.attrs?.cls),
												$safeNavigationMigration(
													fieldObj?.attrs?.clsFn?.(newRow)
												),
											] | clsArr
										"
									>
										<label [class.transparent]="fieldObj.type === 'string'">{{
											fieldObj.langName | langVal
										}}</label>
										<ng-container
											*ngTemplateOutlet="
												rowFields;
												context: {
													curRow: newRow,
													fieldObj: fieldObj,
													isNewRow: true,
												}
											"
										>
										</ng-container>
									</div>
								}
							}
						</div>
					}
					<div class="card-actions-bottom">
						@for (fieldObj of collectionFields; track fieldObj.fieldName) {
							@if (
								genTableService.actionsBottom.includes(fieldObj.type) &&
								!fieldObj.curHidden &&
								fieldObj.type !== "hidden" &&
								((eventsService.isMobile && !fieldObj?.hideOnMobile) ||
									(!eventsService.isMobile && !fieldObj?.hideOnNonMobile))
							) {
								<!-- width: fieldObj?.attrs?.width || 'auto',
										minWidth: fieldObj?.attrs?.minWidth || 'inherit', -->
								<!-- <div
									[style]="{}"
									[className]="
											[fieldObj?.attrs?.cls, fieldObj?.attrs?.clsFn?.(newRow)]
												| clsArr
										"
								> -->
								<ng-container
									*ngTemplateOutlet="
										rowFields;
										context: {
											curRow: newRow,
											fieldObj: fieldObj,
											isNewRow: true,
										}
									"
								/>
								<!-- </div> -->
							}
						}
						<app-btn-ext
							#addRowBtn
							text="add"
							[disabled]="!isFormSubmittable"
							[tabindex]="`${tabindexDomain + 49}`"
							(clickEv)="addNewRow()"
							[isSpin]="isSaving"
							class="add-btn"
						/>
						<div class="d-flex justify-content-end delete-btn-cont">
							<button
								class="btn btn-icon"
								(click)="isNewOpen = false"
								icon="delete"
							></button>
						</div>
					</div>
					<!-- } -->
				</div>
				<!-- <div>
					<div class="new-row-extra">
						<div colspan="99999"></div>
					</div>
				</div> -->
			}
			@for (
				curRow of isClientPagi
					? (objectCollectionShown
						| slice
							: (clientPagiObj.curPage - 1) * clientPagiSize
							: clientPagiObj.curPage * clientPagiSize)
					: objectCollectionShown;
				track curRow
			) {
				<div class="card-container">
					<div
						class="card-wrapper"
						[title]="curRow.html_content_normalized || ''"
						[class.highlight-row]="curRow?.highlight_row"
						[class.highlight-row2]="curRow?.highlight_row2"
						(click)="openExpandedRow($event, curRow)"
					>
						@if (expanded) {
							<div class="action-fields">
								<button
									(click)="openExpandedRow($event, curRow)"
									class="btn btn-icon"
									[icon]="curRow.isExpanded ? 'narrow' : 'expand'"
									titleLang="expand"
								></button>
							</div>
						}
						@if (hasCheckItems) {
							<div class="card-check">
								@if (
									!rowHasCheckedboxIfFunc || rowHasCheckedboxIfFunc(curRow)
								) {
									<app-check
										(onClick)="
											curRow.checked = !curRow.checked;
											emitCheckedItemsChanged()
										"
										[isCheck]="curRow.checked"
									/>
								}
							</div>
						}
						<div class="card-details">
							@for (
								fieldObj of upperCollectionFields;
								track fieldObj.fieldName
							) {
								@if (
									!genTableService.actionsBottom.includes(fieldObj.type) &&
									!fieldObj.curHidden &&
									fieldObj.type !== "hidden" &&
									((eventsService.isMobile && !fieldObj?.hideOnMobile) ||
										(!eventsService.isMobile && !fieldObj?.hideOnNonMobile))
								) {
									<div
										[className]="
											[
												$safeNavigationMigration(fieldObj?.attrs?.cls),
												$safeNavigationMigration(
													fieldObj?.attrs?.clsFn?.(curRow)
												),
											] | clsArr
										"
									>
										@if (fieldObj?.attrs?.showLabel) {
											<label>{{ fieldObj.langName | langVal }}</label>
										}
										<ng-container
											*ngTemplateOutlet="
												rowFields;
												context: {
													curRow: curRow,
													fieldObj: fieldObj,
													isStatic:
														!apiCallPerms.saveField ||
														isEditDisabled ||
														curRow?.is_locked,
												}
											"
										/>
									</div>
								}
							}
						</div>
					</div>
					@if (expanded && curRow.isExpanded) {
						@if (expanded) {
							<div class="expanded">
								@for (
									fieldObj of lowerCollectionFields;
									track fieldObj.fieldName
								) {
									@if (
										!fieldObj.curHidden &&
										fieldObj.type !== "hidden" &&
										!genTableService.actionsBottom.includes(fieldObj.type) &&
										((eventsService.isMobile && !fieldObj?.hideOnMobile) ||
											(!eventsService.isMobile && !fieldObj?.hideOnNonMobile))
									) {
										<div
											[className]="
												[
													$safeNavigationMigration(fieldObj?.attrs?.cls),
													$safeNavigationMigration(
														fieldObj?.attrs?.clsFn?.(curRow)
													),
												] | clsArr
											"
										>
											<label [class.transparent]="fieldObj.type === 'string'">{{
												fieldObj.langName | langVal
											}}</label>
											<ng-container
												*ngTemplateOutlet="
													rowFields;
													context: {
														curRow: curRow,
														fieldObj: fieldObj,
														isStatic:
															!apiCallPerms.saveField ||
															isEditDisabled ||
															curRow?.is_locked,
													}
												"
											>
											</ng-container>
										</div>
									}
								}
								<div class="d-flex w-100 justify-content-end delete-btn-cont">
									<ng-container
										*ngTemplateOutlet="
											deleteBtnEtc;
											context: { curRow: curRow }
										"
									/>
								</div>
							</div>
						}
					}
					<div class="card-actions-bottom">
						@for (fieldObj of collectionFields; track fieldObj.fieldName) {
							@if (
								genTableService.actionsBottom.includes(fieldObj.type) &&
								!fieldObj.curHidden &&
								fieldObj.type !== "hidden" &&
								((eventsService.isMobile && !fieldObj?.hideOnMobile) ||
									(!eventsService.isMobile && !fieldObj?.hideOnNonMobile))
							) {
								<!-- width: fieldObj?.attrs?.width || 'auto',
										minWidth: fieldObj?.attrs?.minWidth || 'inherit', -->
								<!-- <div
									[style]="{}"
									[className]="
											[fieldObj?.attrs?.cls, fieldObj?.attrs?.clsFn?.(curRow)]
												| clsArr
										"
								> -->
								<ng-container
									*ngTemplateOutlet="
										rowFields;
										context: {
											curRow: curRow,
											fieldObj: fieldObj,
											isStatic:
												!apiCallPerms.saveField ||
												isEditDisabled ||
												curRow?.is_locked,
										}
									"
								/>
								<!-- </div> -->
							}
						}
						@if (
							(apiCallPerms.deleteObject || hasUpdateBtn) &&
							!isEditDisabled &&
							!expanded
						) {
							<ng-container
								*ngTemplateOutlet="deleteBtnEtc; context: { curRow: curRow }"
							/>
						}
					</div>
				</div>
			}
		</div>
		@if (
			apiCallPerms.saveNewRow &&
			!isEditDisabled &&
			!avoidNewRow &&
			(addRowIsByPlus || !isNewOpen)
		) {
			<div class="d-flex justify-content-end">
				<button
					class="btn btn-default"
					titleLang="add"
					(click)="prepNewRow()"
					icon="plus"
				>
					{{ "add" | langVal }}
				</button>
			</div>
		}
	}

	@if (addOnlyVis && !restrictedAddMode) {
		<div
			class="text-center"
			style="margin-top: 20px"
		>
			<button
				(click)="addOnlyVis = false"
				class="btn btn-primary"
			>
				{{ "view_all" | langVal }}
			</button>
		</div>
	}

	@if (isClientPagi) {
		<div>
			@if (clientPagiObj.curPage != 1) {
				<button
					class="cal-btn"
					(click)="clientPaginate(-1)"
				>
					&lt;
				</button>
			}
			<span>{{ clientPagiObj.curPage }} / {{ clientPagiObj.lastPage }}</span>
			@if (clientPagiObj.curPage < clientPagiObj.lastPage) {
				<button
					class="cal-btn"
					(click)="clientPaginate(1)"
				>
					&gt;
				</button>
			}
		</div>
	}

	@if (!addOnlyVis && paginationObj) {
		<div>
			@if (paginationObj.curPage != 1) {
				<button
					class="cal-btn"
					(click)="paginate(-1)"
				>
					&lt;
				</button>
			}
			<span>{{ paginationObj.curPage }} / {{ paginationObj.lastPage }}</span>
			@if (paginationObj.curPage < paginationObj.lastPage) {
				<button
					class="cal-btn"
					(click)="paginate(1)"
				>
					&gt;
				</button>
			}
		</div>
		F
	}
</div>

<ng-template
	#rowFields
	let-curRow="curRow"
	let-fieldObj="fieldObj"
	let-isNewRow="isNewRow"
	let-isStatic="isStatic"
>
	<!-- @if(true || (!isNewRow && fieldObj?.attrs?.staticOnEdit)){ -->
	@if (!isNewRow && fieldObj?.attrs?.staticOnEdit) {
		<!-- only here if field is static on edit -->
		@switch (fieldObj.type) {
			@case ("wysiwyg") {
				<div
					class="static"
					[innerHTML]="
						fieldObj.attrs?.outputLang
							? curRow[fieldObj.fieldName | langVal]
							: (curRow[fieldObj.fieldName] | safeHtml)
					"
				></div>
			}
			@case ("date") {
				<div
					class="static"
					[innerHTML]="curRow[fieldObj.fieldName] | dateFormat | safeHtml"
				></div>
			}
			@case ("time") {
				<div class="static">
					@if (fieldObj?.attrs?.localTime) {
						{{ toLocalTime(curRow[fieldObj.fieldName]) }}
					} @else {
						{{ curRow[fieldObj.fieldName] | timeFormat }}
					}
				</div>
			}
			@default {
				<div class="static">
					{{
						curRow[fieldObj.fieldName + "_staticDisplayValue"] ??
							curRow[fieldObj.fieldName]
					}}
				</div>
			}
		}
	} @else {
		<!-- either I'm new row OR I'm existing row and not static -->

		@if (fieldObj.type | inArray: ["input", "textarea", "staticOrInput"]) {
			@if (!fieldObj.attrs?.showFn || fieldObj.attrs.showFn(curRow)) {
				@if (fieldObj.attrs?.prefixText) {
					<span class="static prefix">
						{{ fieldObj.attrs?.prefixText | langVal }}
					</span>
				}

				<app-gen-input
					[errors]="curRow.errors"
					[actualObj]="curRow"
					[fieldName]="fieldObj.fieldName"
					(keyupEvent)="validateField(curRow, fieldObj.fieldName, isNewRow)"
					[type]="fieldObj.type"
					[isStatic]="
						isStatic ||
						(fieldObj.type === 'staticOrInput' &&
							fieldObj.attrs.isStatic(curRow))
					"
					[height]="fieldObj.attrs?.height || ''"
					#focusableField
					[isNumber]="fieldObj?.isNumberField"
					(changeEvent)="
						isNewRow
							? validateEntireForm()
							: validateAndSaveField(curRow, fieldObj)
					"
					[genTableVars]="{
						curRow: curRow,
						fieldObj: fieldObj,
						isNewRow: isNewRow,
						tabindexDomain: tabindexDomain,
					}"
				/>
			}
		}
		@if (fieldObj.type | inArray: ["file", "image"]) {
			<app-gen-file-input
				[fileType]="fieldObj.type"
				[fieldName]="fieldObj.fieldName"
				[actualObj]="curRow"
				[errors]="curRow.errors"
				[urlTemplate]="fieldObj.attrs.urlTemplate"
				[maxDims]="$safeNavigationMigration(fieldObj.attrs?.maxDims)"
				[isStatic]="isStatic"
				(changeEvent)="
					updFilesObj(curRow, fieldObj.fieldName, $event);
					isNewRow
						? validateEntireForm()
						: validateAndSaveField(curRow, fieldObj)
				"
				[genTableVars]="{
					curRow: curRow,
					fieldObj: fieldObj,
					isNewRow: isNewRow,
					tabindexDomain: tabindexDomain,
				}"
			/>
		}
		@if (fieldObj.type | inArray: ["fuzzy", "fuzzy-api"]) {
			<div class="fuzzy-wrap">
				<app-gen-autocomplete
					#focusableField
					[error]="curRow.errors[fieldObj.fieldName]"
					[fieldName]="fieldObj.fieldName"
					[searchStr]="curRow[fieldObj.attrs.displayStringFieldName] || ''"
					[fuzzySearchableClasses]="
						fieldObj.type == 'fuzzy' ? fieldObj.fuzzyArr : []
					"
					(chosenEvent)="autocompleteChoice($event, curRow, fieldObj, isNewRow)"
					(keyUp)="autocompleteKeyUp($event, curRow, fieldObj, isNewRow)"
					[actualObj]="curRow"
					[fuzzySearchObj]="
						$safeNavigationMigration(fieldObj.attrs?.fuzzySearchObj)
					"
					[optionDisplay]="
						$safeNavigationMigration(fieldObj.attrs?.optionDisplay)
					"
					[objectFieldToSave]="fieldObj.attrs.objectFieldToSave || 'id'"
					[width]="'100%'"
					[outerFilterValue]="
						curRow[fieldObj.attrs?.fuzzySearchObj?.outerFilterName]
					"
					[searchStrFieldName]="fieldObj.attrs.displayStringFieldName"
					[isStatic]="isStatic"
					[hasPlus]="
						!fieldObj.attrs.avoidPlus &&
						(!fieldObj.attrs?.showPlusPerm ||
							permsService.perms[fieldObj.attrs?.showPlusPerm])
					"
					[plusLang]="$safeNavigationMigration(fieldObj?.langName)"
					(plusClick)="openAddFuzzyModal(curRow, fieldObj, isNewRow)"
					[genTableVars]="{
						curRow: curRow,
						fieldObj: fieldObj,
						isNewRow: isNewRow,
						tabindexDomain: tabindexDomain,
					}"
				/>
				<!-- show the plus if both:
        1. there's no avoid
        2. either THERE IS NO NEED FOR PERM or THERE IS A NEED FOR PERM AND I HAVE IT -->
			</div>
		}

		@switch (fieldObj.type) {
			@case ("staticIcon") {
				<span
					[titleLang]="curRow[fieldObj.langName]"
					class="flex-center"
					[preIcon]="curRow[fieldObj.fieldName]"
				>
					{{ curRow[fieldObj.fieldName] | langVal }}</span
				>
			}
			@case ("static") {
				@if (!fieldObj.attrs?.showFn || fieldObj.attrs?.showFn(curRow)) {
					@if (fieldObj.attrs?.outputLang) {
						<div
							class="static"
							[innerHTML]="
								toPtoformaLang(curRow, fieldObj.fieldName) | langVal | safeHtml
							"
						></div>
					} @else {
						@if (curRow[fieldObj.fieldName]) {
							@if (fieldObj.attrs?.prefixText) {
								<span class="static prefix">
									{{
										$safeNavigationMigration(fieldObj.attrs?.prefixText)
											| langVal
									}}</span
								>
							}
							<span
								class="static bold"
								[innerHTML]="
									curRow[fieldObj.fieldName + '_staticDisplayValue'] ??
										(curRow[fieldObj.fieldName] || '') | safeHtml
								"
							></span>
						}
					}
				}
			}
			@case ("button-group") {
				@if (!fieldObj.attrs?.showFn || fieldObj.attrs?.showFn(curRow)) {
					<app-gen-button-group
						[actualObj]="curRow"
						[fieldName]="fieldObj.fieldName"
						[options]="fieldObj.optionsCollection"
						[errors]="curRow.errors"
						[disabled]="isStatic"
						(changeEvent)="
							isNewRow
								? validateEntireForm(curRow, fieldObj)
								: validateAndSaveField(curRow, fieldObj)
						"
						[genTableVars]="{
							curRow: curRow,
							fieldObj: fieldObj,
							isNewRow: isNewRow,
							tabindexDomain: tabindexDomain,
						}"
					/>
				}
			}
			@case ("yes-no") {
				<div>
					<div class="switch-btn switch-btn-subtle">
						<app-yes-no
							(onClick)="changeYesNo(curRow, fieldObj, isNewRow)"
							[isCheck]="curRow[fieldObj.fieldName] == 'yes'"
							[disabled]="isStatic"
						/>
						<label (click)="changeYesNo(curRow, fieldObj, isNewRow)">
							{{
								$safeNavigationMigration(fieldObj.attrs?.suffixText) | langVal
							}}
						</label>
					</div>
					@if (curRow.errors[fieldObj.fieldName]) {
						<p class="error">{{ curRow.errors[fieldObj.fieldName] }}</p>
					}
				</div>
			}
			@case ("color") {
				<app-color-select
					[value]="curRow[fieldObj.fieldName]"
					(onChange)="handleColorChange(curRow, fieldObj, isNewRow, $event)"
				/>
			}
			@case ("select") {
				<app-gen-select
					[actualObj]="curRow"
					[options]="fieldObj.optionsCollection"
					[fieldName]="fieldObj.fieldName"
					#focusableField
					optionFieldId="value"
					[errors]="curRow.errors"
					[disabled]="
						!isNewRow &&
						(!apiCallPerms.saveField || isEditDisabled || curRow?.is_locked)
					"
					(changeEvent)="
						isNewRow
							? validateEntireForm()
							: validateAndSaveField(curRow, fieldObj)
					"
					[genTableVars]="{
						curRow: curRow,
						fieldObj: fieldObj,
						isNewRow: isNewRow,
						tabindexDomain: tabindexDomain,
					}"
				/>
			}
			@case ("wysiwyg") {
				<app-wysiwyg
					[actualObj]="curRow"
					[fieldName]="fieldObj.fieldName"
					[isStatic]="isStatic"
					[errors]="curRow.errors"
					#focusableField
					(changeEvent)="
						isNewRow
							? validateEntireForm()
							: validateAndSaveField(curRow, fieldObj)
					"
					[isDocumentTemplate]="tableName == 'documenttemplates'"
					[genTableVars]="{
						curRow: curRow,
						fieldObj: fieldObj,
						isNewRow: isNewRow,
						tabindexDomain: tabindexDomain,
					}"
				/>
			}
			@case ("tags-ac") {
				<div>
					@if (isNewRow) {
						<app-autocomplete-with-tags
							#newRowTags
							[hasPlus]="!fieldObj.attrs?.avoidPlus"
							(chosenEvent)="newRowTagsChoice($event, fieldObj)"
						/>
					} @else {
						<app-autocomplete-with-tags
							saveMode
							[hasPlus]="
								!fieldObj.attrs?.avoidPlus &&
								!(!apiCallPerms.saveField || isEditDisabled)
							"
							[item_id]="curRow.id"
							[item_type]="
								$safeNavigationMigration(fieldObj.attrs?.tagItemType)
							"
							[isStatic]="isStatic"
						/>
					}
				</div>
			}
			@case ("assoc-users") {
				<div>
					@if (isNewRow) {
						<app-autocomplete-multi
							#newRowAssoc
							(chosenEvent)="onNewRowMultiAcValuesChange($event, fieldObj)"
							[excludeIds]="excludeIds"
							[isStatic]="isStatic"
							[siteDataFilters]="{ active: 'yes' }"
							siteDataTable="sub_users"
						/>
					} @else {
						<app-autocomplete-multi
							siteDataTable="sub_users"
							[ids]="curRow[fieldObj.fieldName]"
							(addItem)="assocAddItem($event, curRow, fieldObj)"
							[siteDataFilters]="{ active: 'yes' }"
							[isStatic]="isStatic"
							(deleteItem)="assocDeleteItem($event, curRow, fieldObj)"
							[excludeIds]="excludeIds"
						/>
					}
				</div>
			}
			@case ("autocomplete-multi") {
				<div>
					@if (isNewRow) {
						<app-autocomplete-multi
							#newRowAcMulti
							(chosenEvent)="onNewRowMultiAcValuesChange($event, fieldObj)"
							[isStatic]="isStatic"
						/>
					} @else {
						<app-autocomplete-multi
							[ids]="curRow[fieldObj.fieldName]"
							(addItem)="onMultiAcAddItem($event, curRow, fieldObj)"
							[isStatic]="isStatic"
							(deleteItem)="onMultiAcDeleteItem($event, curRow, fieldObj)"
						/>
					}
				</div>
			}
			@case ("created_at") {
				@if (!isNewRow) {
					<div class="static">
						{{ curRow[fieldObj.fieldName] | dateFormat }}
					</div>
				}
			}
			@case ("date") {
				<app-date-picker
					[actualObj]="curRow"
					[fieldName]="fieldObj.fieldName"
					[errors]="curRow.errors"
					[isStatic]="isStatic"
					(changeEvent)="
						updateDateField(curRow, fieldObj);
						isNewRow
							? validateEntireForm()
							: validateAndSaveField(curRow, fieldObj);
						tryToFocusOnNextField(curRow, fieldObj, isNewRow)
					"
					[genTableVars]="{
						curRow: curRow,
						fieldObj: fieldObj,
						isNewRow: isNewRow,
						tabindexDomain: tabindexDomain,
					}"
					[disabledAfterToday]="
						$safeNavigationMigration(fieldObj?.attrs?.disabledAfterToday)
					"
				/>
			}
			@case ("time") {
				<app-time-picker
					[actualObj]="curRow"
					[fieldName]="fieldObj.fieldName"
					[errors]="curRow.errors"
					[isStatic]="isStatic"
					(changeEvent)="
						isNewRow
							? validateEntireForm()
							: validateAndSaveField(curRow, fieldObj)
					"
					[genTableVars]="{
						curRow: curRow,
						fieldObj: fieldObj,
						isNewRow: isNewRow,
						tabindexDomain: tabindexDomain,
					}"
				/>
			}
			@case ("modal-input") {
				@if (!isNewRow) {
					<app-gen-table-modal-input
						[attrs]="fieldObj.attrs"
						[value]="curRow[fieldObj.fieldName]"
						(onChange)="
							handleModalInputClose(curRow, fieldObj, isNewRow, $event)
						"
					/>
				}
			}
			@case ("button") {
				@if (isNewRow) {
					@if (fieldObj.fieldName == "assoc") {
						<app-gen-autocomplete
							#focusableField
							[error]="curRow.errors[fieldObj.fieldName]"
							[fieldName]="fieldObj.fieldName"
							[fuzzySearchableClasses]="['sub_users']"
							[searchStr]="curRow?.assoc_name || ''"
							[searchStrFieldName]="'assoc_name'"
							(chosenEvent)="
								autocompleteChoice($event, curRow, fieldObj, isNewRow)
							"
							(keyUp)="autocompleteKeyUp($event, curRow, fieldObj, isNewRow)"
							[actualObj]="curRow"
							[width]="'100%'"
							[genTableVars]="{
								curRow: curRow,
								fieldObj: fieldObj,
								isNewRow: isNewRow,
								tabindexDomain: tabindexDomain,
							}"
						/>
					}

					@if (fieldObj?.attrs?.isInputInNewRow) {
						<app-gen-input
							[fieldName]="fieldObj.fieldName"
							[actualObj]="curRow"
							[errors]="curRow.errors"
							#focusableField
							(keyupEvent)="validateField(curRow, fieldObj.fieldName, isNewRow)"
							[height]="fieldObj.attrs?.height || ''"
							(changeEvent)="validateEntireForm()"
							[genTableVars]="{
								curRow: curRow,
								fieldObj: fieldObj,
								isNewRow: isNewRow,
								tabindexDomain: tabindexDomain,
							}"
						/>
					}
				} @else {
					@if (
						!fieldObj.attrs?.isShownField || curRow[fieldObj.attrs.isShownField]
					) {
						<app-gen-table-field-btn
							isV2
							[attrs]="fieldObj.attrs"
							[row]="curRow"
							[tableName]="tableName"
						/>
						<!-- visible if not new row AND
              EITHER isShownField doesn't exist OR isShownField has a truthy value in this row (ex. isCreditable)  -->
					}
				}
			}
			@case ("string") {
				<div class="static">{{ fieldObj.fieldName }}</div>
			}
			@case ("otherSiteDataTableValue") {
				<div class="static">
					{{ otherSiteDataTableValue(curRow, fieldObj) }}
				</div>
			}
			@case ("otherSiteDataTableValueMinusField") {
				<div class="static">
					{{ otherSiteDataTableValueMinusField(curRow, fieldObj) }}
				</div>
			}
		}

		@if (!isNewRow) {
			@switch (fieldObj.type) {
				@case ("inquiry-status") {
					<div class="static">
						{{ inquiry_statuses_names_obj[curRow.inquiry_status_id] || "" }}
					</div>
				}

				@case ("action-button") {
					@if (!fieldObj.attrs?.showFn || fieldObj.attrs.showFn(curRow)) {
						<app-spin-or-content
							[isSpin]="curRow[fieldObj.fieldName + '_isSpin']"
						>
							@if (fieldObj?.attrs?.icon) {
								<button
									class="btn"
									[icon]="$safeNavigationMigration(fieldObj?.attrs?.icon)"
									(click)="this[fieldObj.attrs.clickFunc](curRow, fieldObj)"
								></button>
							} @else {
								<button
									class="btn btn-primary"
									(click)="this[fieldObj.attrs.clickFunc](curRow, fieldObj)"
								>
									{{
										(fieldObj.attrs?.displayStringFieldName
											? curRow[fieldObj.attrs.displayStringFieldName]
											: fieldObj.langName
										) | langVal
									}}
								</button>
							}
						</app-spin-or-content>
					}
				}
				@case ("show-item") {
					<app-spin-or-content
						[isSpin]="$safeNavigationMigration(curRow?.isLoadingPerson)"
					>
						<button
							class="btn btn-icon"
							(click)="handleShowItemClick(curRow, fieldObj)"
							icon="show"
						></button>
					</app-spin-or-content>
				}
				@case ("external-link") {
					<button
						class="btn btn-icon"
						(click)="goToExternalLink(curRow.id)"
						icon="copy"
					></button>
				}
				@case ("whatsapp") {
					@if (curRow?.contactway_identifier == "phone") {
						<button class="btn btn-default">
							<a
								[href]="
									'https://' +
									(eventsService.isMobile || isWaAppInstalled ? 'api' : 'web') +
									'.whatsapp.com/send/?phone=972' +
									$safeNavigationMigration(curRow?.contactway)
								"
								target="_blank"
								icon="whatsapp"
							>
								@if (isButtonsWithLabels) {
									<span class="showtext">
										{{
											$safeNavigationMigration(fieldObj.attrs?.suffixText)
												| langVal
										}}</span
									>
								}
							</a>
						</button>
						<!--https://api.whatsapp.com/send/?phone=0544656100-->
					}
					@if (curRow?.phone_mobile) {
						<button class="btn btn-icon">
							<a
								[href]="
									'https://' +
									(eventsService.isMobile || isWaAppInstalled ? 'api' : 'web') +
									'.whatsapp.com/send/?phone=972' +
									$safeNavigationMigration(curRow?.phone_mobile)
								"
								target="_blank"
								icon="whatsapp"
							></a>
						</button>
					}
				}
				@case ("phone") {
					@if (curRow?.contactway_identifier == "phone") {
						<button class="btn btn-default">
							<a
								[href]="'tel:' + $safeNavigationMigration(curRow?.contactway)"
								target="_blank"
								icon="phone"
							>
								@if (isButtonsWithLabels) {
									<span class="showtext">
										{{
											$safeNavigationMigration(fieldObj.attrs?.suffixText)
												| langVal
										}}</span
									>
								}
							</a>
						</button>
					}
				}
				@case ("pdf-view") {
					@if (!fieldObj.attrs?.showFn || fieldObj.attrs?.showFn(curRow)) {
						<app-spin-or-content
							[isSpin]="$safeNavigationMigration(curRow?.pdfViewSpin)"
						>
							<button
								class="btn btn-default"
								(click)="downloadAndViewResource(curRow)"
								titleLang="pdf-view"
								preIcon="preview"
							>
								@if (isButtonsWithLabels) {
									<span class="showtext">
										{{
											$safeNavigationMigration(fieldObj.attrs?.suffixText)
												| langVal
										}}</span
									>
								}
							</button>
						</app-spin-or-content>
					}
				}
				@case ("translate") {
					@if (!fieldObj.attrs?.showFn || fieldObj.attrs?.showFn(curRow)) {
						<app-spin-or-content
							[isSpin]="$safeNavigationMigration(curRow?.pdfViewSpin)"
						>
							<app-gen-table-field-btn
								isV2
								[row]="curRow"
								[attrs]="{
									modal: 'finresource-translation',
									icon: 'translate',
									title: 'en',
									suffixText: isButtonsWithLabels && fieldObj.attrs?.suffixText,
								}"
							/>
						</app-spin-or-content>
					}
				}
				@case ("credit") {
					@if (
						!fieldObj.attrs?.isShownField || curRow[fieldObj.attrs.isShownField]
					) {
						<app-spin-or-content
							[isSpin]="$safeNavigationMigration(curRow?.pdfViewSpin)"
						>
							<app-gen-table-field-btn
								isV2
								[row]="curRow"
								[attrs]="{
									modal: 'finresource-credit',
									icon: 'credit',
									title: 'credit_invoice_short',
									suffixText: isButtonsWithLabels && fieldObj.attrs?.suffixText,
								}"
							/>
						</app-spin-or-content>
					}
				}
				@case ("download") {
					@if (
						curRow.type || fieldObj?.attrs?.downloadType
							| inArray: downloadAndEmailTypes
					) {
						<app-spin-or-content
							[isSpin]="$safeNavigationMigration(curRow?.downloadSpin)"
						>
							<button
								class="btn btn-default"
								(click)="downloadFinResource(curRow)"
								titleLang="download"
								preIcon="download"
							>
								@if (isButtonsWithLabels) {
									<span class="showtext"
										>{{
											$safeNavigationMigration(fieldObj.attrs?.suffixText)
												| langVal
										}}
									</span>
								}
							</button>
						</app-spin-or-content>
					}
				}
				@case ("duplicate") {
					<app-spin-or-content
						[isSpin]="$safeNavigationMigration(curRow?.dupSpin)"
					>
						<button
							class="btn btn-icon"
							(click)="duplicate(curRow)"
							titleLang="duplicate"
							icon="copy"
						>
							<span class="showtext">
								{{
									$safeNavigationMigration(fieldObj.attrs?.suffixText) | langVal
								}}</span
							>
						</button>
					</app-spin-or-content>
				}
				@case ("renew") {
					<app-spin-or-content
						[isSpin]="$safeNavigationMigration(curRow?.renewSpin)"
					>
						<button
							class="btn btn-icon"
							(click)="renew(curRow)"
							titleLang="renew"
							preIcon="arow-left"
						>
							<span class="showtext">
								{{
									$safeNavigationMigration(fieldObj.attrs?.suffixText) | langVal
								}}</span
							>
						</button>
					</app-spin-or-content>
				}
				@case ("document-action") {
					@if (curRow?.doc_type == "html") {
						<!--            signed:{{curRow?.signed}}-->
						<!--            for_signing:{{curRow?.for_signing}}-->
						<button
							class="btn btn-default actions"
							(click)="documentAction(curRow)"
						>
							@if (curRow?.signed == "yes") {
								<app-icon icon="copy" />
								@if (isButtonsWithLabels) {
									<span class="showtext">
										{{
											$safeNavigationMigration(fieldObj.attrs?.suffixText)
												| langVal
										}}</span
									>
								}
							} @else {
								@if (curRow?.for_signing == "yes") {
									<app-icon icon="sign_document" />
									@if (isButtonsWithLabels) {
										<span class="showtext">{{
											"sign_document" | langVal
										}}</span>
									}
								} @else {
									<app-icon icon="edit" />
									@if (isButtonsWithLabels) {
										<span class="showtext">{{ "edit" | langVal }}</span>
									}
								}
							}
						</button>
					}
				}
				@case ("mail-to") {
					@if (
						curRow.type || fieldObj?.attrs?.downloadType
							| inArray: downloadAndEmailTypes
					) {
						<button
							class="btn btn-default"
							(click)="downloadAndEmail(curRow)"
							preIcon="email"
						>
							@if (isButtonsWithLabels) {
								<span class="showtext">
									{{
										$safeNavigationMigration(fieldObj.attrs?.suffixText)
											| langVal
									}}</span
								>
							}
						</button>
					}
				}
			}
		}

		@if (fieldObj.attrs?.headturesInsert) {
			<button
				class="btn btn-primary btn-bottom"
				(click)="
					headturesInsert(curRow, fieldObj);
					isNewRow
						? validateEntireForm()
						: validateAndSaveField(curRow, fieldObj)
				"
			>
				{{ "generate_header" | langVal }}
			</button>
		}
	}
</ng-template>

<ng-template
	#deleteBtnEtc
	let-curRow="curRow"
>
	<div class="flex-v-center">
		@if (hasUpdateBtn) {
			<app-btn-ext
				text="update"
				[disabled]="!curRow.isRowSubmittable"
				(clickEv)="updateRow(curRow)"
				[isSpin]="curRow.isUpdatingSpinner"
			/>
		}

		<app-spin-or-content [isSpin]="curRow.isDeleting">
			@if (
				apiCallPerms.deleteObject &&
				!curRow.is_documented &&
				curRow?.for_signing != "yes" &&
				!curRow?.is_locked
			) {
				<button
					class="btn btn-icon"
					(click)="delete(curRow); $event.stopPropagation()"
					[disabled]="curRow.isDeleting"
					titleLang="delete"
					preIcon="delete"
				>
					<!-- <span class="showtext">{{ "delete" | langVal }} </span> -->
				</button>
			}
		</app-spin-or-content>
	</div>
</ng-template>
@switch (modalProps?.name) {
	@case ("referer-patients") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			hasExit
			title="referred_patients"
		>
			<app-referer-patients
				(onClose)="modalProps = null"
				[id]="modalProps.id"
			/>
		</app-modal-wrap>
	}
	@case ("add-document") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="letter"
			modalWrapperClass="modal-800"
		>
			<app-add-document
				(onClose)="modalProps = null"
				[documentObj]="modalProps.newRow"
				[performValidation]="modalProps.performValidation"
				[patient_id]="modalProps.newRow.patient_id"
				[payor_id]="modalProps.newRow.payor_id"
				[user_id]="modalProps.newRow.user_id"
			/>
		</app-modal-wrap>
	}
	@case ("insert-patient-form") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="insert_patient_form"
			modalWrapperClass="modal-800"
		>
			<app-insert-patient-form (onClose)="handleFuzzyAddClose($event)" />
		</app-modal-wrap>
	}

	@case ("gen-table-add-item") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			[title]="modalProps.fieldObj.attrs.tableName | tableNameDisplay"
			modalWrapperClass="modal-fit-content"
		>
			<app-gen-table-add-item
				(onClose)="handleFuzzyAddClose($event)"
				[tableName]="modalProps.fieldObj.attrs.tableName"
				[fuzzyName]="
					modalProps.row[modalProps.fieldObj.fieldName + '_fuzzy_val3465']
				"
			/>
		</app-modal-wrap>
	}
	@case ("table-display-contactways") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="contactways"
			modalWrapperClass="modal-wide"
		>
			<app-gen-table-display
				(onClose)="handleConactwaysClose($event)"
				tableName="contactways"
				[filterField]="modalProps.fieldName"
				[filterFieldValue]="modalProps.row[modalProps.fieldName]"
				fieldNameInItemToDisplay="contactway"
				isCheckItems
				[filterFieldApiObject]="modalProps.filterFieldApiObject"
				[emailsAndPhoneValidation]="modalProps.emailsAndPhoneValidation"
			/>
		</app-modal-wrap>
	}
	@case ("confirm-delete") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="do_you_confirm_delete"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="$event ? handleDeleteApprove() : (modalProps = null)"
				[objectName]="modalProps.objectName"
			/>
		</app-modal-wrap>
	}
	@case ("confirm-change") {
		<app-modal-wrap
			(onClose)="handleConfirmChange(false)"
			title="do_you_confirm_change"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="handleConfirmChange($event)"
				[objectName]="modalProps.objectName"
			/>
		</app-modal-wrap>
	}
	@case ("confirm-duplicate-new-row") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="confirm_duplicate"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="modalProps = null; $event && handleNewRowDuplicateApprove()"
				[objectName]="modalProps.objectName"
			/>
		</app-modal-wrap>
	}
	@case ("confirm-duplicate") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="confirm_duplicate"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="
					$event
						? handleDuplicateApprove(modalProps.curRow, modalProps.fieldObj)
						: (modalProps = null)
				"
				[objectName]="modalProps.objectName"
			/>
		</app-modal-wrap>
	}
}
